import React from 'react';

import UserForm from './UserForm';

import style from './UserForm.module.css';

const EditUserForm = React.memo(({ location, ...props }) => {
  const userState = location.state || {};

  return (
    <>
      {userState.isEditUser ? (
        <div className={style.user}>
          <h2 className={style.header}>Edit User Information</h2>
          <UserForm style={style} userState={userState} {...props} />
        </div>
      ) : null}
    </>
  );
});

EditUserForm.propTypes = {};

export default EditUserForm;
